module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; 
var attributes = Html.attributes(_.reduce(_.pick(item, 'id', 'kindid', 'kindattributeid', 'name', 'type', 'layername'), function(result, value, key) {
    result['data-' + key] = value;
    return result;
}, {}));

    ; __append("\n\n<li class='gis-menu-list-item' name=\"subItem\" ")
    ; __append( attributes )
    ; __append(" >\n	<span class=\"icon-drag_handle icon-24 gis-menu-item-handle\"></span>\n    <label on-click=\"onSubItemClick\">\n        <input type='checkbox' ")
    ; __append(escapeFn( item.active?'checked':'' ))
    ; __append(" state-holder> ")
    ; __append( item.name || item.label )
    ; __append("\n    </label>\n	")
    ;  if (item.layer.dates) { 
    ; __append("\n		<span style=\"position: absolute; right:12px;cursor: pointer;top: 50%;margin-top: -12px;\" on-click=\"onHistoryClick\">\n			<span class=\"icon-schedule icon-24\"></span>\n		</span>\n	")
    ;  } 
    ; __append("\n</li>")
  }
  return __output.join("");

}